"use strict";

import angular from "angular";
import template from "./systems-select-list.component.html";
import "./systems-select-list.component.scss";
import { Events } from "../../../presentation/services/Events/Events";
import { NormalizeString } from "../../../utils/normalize-string/NormalizeString";

class SystemsSelectListComponent {
    Events = new Events();
    selectedSystems = [];
    searchText = "";
    filteredSystems = [];
    constructor() {}
    $onInit() {
        if (this.selectedSystems) {
            this.selectedSystems = angular.copy(this.selectedSystems);
        }
        this.filteredSystems = [...this.systems];
    }
    $onChanges(changes) {
        if (changes.triggerScroll) {
            this.scrollToSelectedSystem();
        }
        if (changes.selectedSystems && changes?.selectedSystems?.currentValue) {
            this.selectedSystems = angular.copy(
                changes.selectedSystems.currentValue
            );
        }
    }
    selectOtherSystem(system) {
        this.Events.send(
            `contabilidade.defninirsistemas.selecionou.${system.name}`
        );
        if (this.onSelectSystem) {
            this.onSelectSystem({ system: system });
        }
        this.clearSearch();
    }
    selectSystem(system) {
        this.Events.send(
            `contabilidade.defninirsistemas.selecionou.${system.name}`
        );
        if (!this.multiple && this.onSelectSystem) {
            this.onSelectSystem({ system: system });
        }
        this.clearSearch();
    }
    toggleSystemSelection(system) {
        if (!this.multiple) return;
        if (this.isDisabled(system)) return;
        const index = this.selectedSystems.findIndex(
            (s) => s.value === system.value
        );
        if (index > -1) {
            this.selectedSystems.splice(index, 1);
        } else {
            this.Events.send(
                `contabilidade.defninirsistemas.selecionou.${system.name}`
            );
            this.selectedSystems.push(system);
        }
    }
    isSystemSelected(system) {
        if (!this.selectedSystems) return false;
        return this.selectedSystems.some((s) => s.value === system.value);
    }
    applySelection() {
        if (this.multiple && this.onApply) {
            this.onApply({ systems: this.selectedSystems });
        }
        this.selectedSystems = [];
        this.clearSearch();
        this.Events.send(`contabilidade.defninirsistemas.aplicar`);
    }
    filterSystems() {
        if (!this.searchText || this.searchText.trim() === "") {
            this.filteredSystems = [...this.systems];
        } else {
            const searchTerm = NormalizeString.normalizeUpperCaseNd(
                this.searchText
            );
            this.filteredSystems = this.systems.filter((system) =>
                NormalizeString.normalizeUpperCaseNd(system.name).includes(
                    searchTerm
                )
            );
        }
    }
    clearSearch() {
        this.searchText = "";
        this.filteredSystems = [...this.systems];
    }
    scrollToSelectedSystem() {
        setTimeout(() => {
            const listContainer = document.querySelector(
                ".systems-select-list__content"
            );
            if (!listContainer) {
                return;
            }
            let targetElement = null;
            if (this.multiple) {
                targetElement = listContainer.querySelector(
                    '.items-list li[data-system-selected="true"]'
                );
            } else {
                if (this.currentSelectedSystem) {
                    targetElement = listContainer.querySelector(
                        `.items-list li[data-system-value="${this.currentSelectedSystem.value}"]`
                    );
                }
            }
            if (!targetElement) {
                return;
            }
            const containerHeight = listContainer.clientHeight;
            const elementHeight = targetElement.offsetHeight;
            const elementTop = targetElement.offsetTop;
            const scrollTop =
                elementTop - containerHeight / 2 + elementHeight / 2;
            listContainer.scrollTo({
                top: Math.max(0, scrollTop),
                behavior: "smooth"
            });
        }, 500);
    }
    isDisabled(system) {
        const isSelected = this.isSystemSelected(system);
        return (
            !isSelected &&
            this.selectedSystems?.filter(
                (s) => !["others", "none"].includes(s.value)
            )?.length >= 3
        );
    }
}

SystemsSelectListComponent.$inject = [];

export { SystemsSelectListComponent };

const name = "systemsSelectListComponent";
const def = {
    bindings: {
        selectedSystems: "<",
        multiple: "<",
        systems: "<",
        otherOptions: "<",
        onApply: "&",
        onSelectSystem: "&",
        currentSelectedSystem: "<",
        triggerScroll: "<"
    },
    controller: SystemsSelectListComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
